import "@/utils/net/http.ts"; // 初始化 HTTP 客户端，必须在所有 API 调用之前执行
import { createRoot } from "react-dom/client";
import "./globals.css";
import { RouterProvider, createRouter, parseSearchWith, stringifySearchWith } from "@tanstack/react-router";
import { parseSearchValue } from "@repo/utils/search-params";
import { routeTree } from "./routeTree.gen";
import * as Sentry from "@sentry/react";

Sentry.init({
  environment: import.meta.env.MODE,
  dsn: "https://4129f38df4295f1e1361b62648a45f95@sentry.furries.cn/4",
  dataCollection: {
    userInfo: true,
  },
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const router = createRouter({
  routeTree,
  // 整数 query 保持字符串，避免雪花 ID 被 JSON.parse 成 Number 丢精度
  parseSearch: parseSearchWith(parseSearchValue),
  // 不把 "123" 再 JSON.stringify 成 "\"123\""，UID / 订单号保持 ?id=123
  stringifySearch: stringifySearchWith(JSON.stringify),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(<RouterProvider router={router} />);
